module.exports = __webpack_public_path__ + "img/yunshanfu@2x.c4d4b7c5.png";